"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var axios_1 = __importDefault(require("axios"));
var get_1 = __importDefault(require("lodash/get"));
var CustomerApi = (function () {
    function CustomerApi(props) {
        var _this = this;
        this.isLocalhost = false;
        this.apiSecret = "";
        this.customerId = "";
        this.customerIdSignature = "";
        this.customerType = "";
        this.addProductsToCart = function (items) {
            return _this.ajaxApi.post("/cart/add.js", {
                items: items,
            });
        };
        this.isLocalhost = window.location.hostname === "localhost";
        if (this.isLocalhost && !props.urlStem) {
            console.log("Wishlist will be non-functional for local development");
        }
        var proxy = props.proxy || "/a/proxy";
        this.proxyApi = axios_1.default.create({
            baseURL: "" + window.location.origin + proxy,
            timeout: 60000,
            headers: {
                "Content-Type": "application/json",
            },
        });
        this.ajaxApi = axios_1.default.create({
            baseURL: window.location.origin,
            timeout: 60000,
            headers: {
                "Content-Type": "application/json",
            },
        });
        Object.assign(this, props);
    }
    CustomerApi.prototype.appendCustomerParamsPlusJunk = function (url, queryParams, isLocalhost, apiSecret, customerId, customerIdSignature) {
        queryParams = queryParams || [];
        queryParams.push("cid=" + customerId);
        queryParams.push("cidsig=" + customerIdSignature);
        url += "?" + queryParams.join("&");
        return url;
    };
    CustomerApi.prototype.appendCustomerParams = function (url, queryParams) {
        if (queryParams === void 0) { queryParams = []; }
        return this.appendCustomerParamsPlusJunk(url, queryParams, this.isLocalhost, this.apiSecret, this.customerId, this.customerIdSignature);
    };
    CustomerApi.prototype.call = function (_a) {
        var _b = _a.api, api = _b === void 0 ? this.proxyApi : _b, url = _a.url, _c = _a.queryParams, queryParams = _c === void 0 ? [] : _c, _d = _a.postData, postData = _d === void 0 ? {} : _d, _e = _a.type, type = _e === void 0 ? "get" : _e;
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_f) {
                switch (_f.label) {
                    case 0:
                        if (type == "get") {
                            url = this.appendCustomerParams(url, queryParams);
                        }
                        if (type == "post" && this.customerId && this.customerIdSignature) {
                            postData.cid = this.customerId;
                            postData.cidsig = this.customerIdSignature;
                        }
                        postData.validStatus = function (status) {
                            return status < 500;
                        };
                        return [4, api[type](url, postData)];
                    case 1:
                        response = _f.sent();
                        if (!(response && response.data && response.data.success)) {
                            throw new Error("API error");
                        }
                        return [2, response];
                }
            });
        });
    };
    CustomerApi.prototype.update = function (_a) {
        var name = _a.name, id = _a.id, value = _a.value;
        var url, values, method = "put";
        switch (name) {
            case "wishlist":
                url = "/wishlist/update";
                values = { wishlist: value };
                method = "post";
                break;
            case "test":
                return new Promise(function (resolve) {
                    setTimeout(resolve, 2000);
                });
            default:
                return console.error("update :: Can't update with field: " + name);
        }
        url = this.appendCustomerParams(url);
        return this.proxyApi[method](url, __assign({ cid: this.customerId, cidsig: this.customerIdSignature }, values));
    };
    CustomerApi.prototype.getWishlist = function () {
        return __awaiter(this, void 0, void 0, function () {
            var response, e_1, errors;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4, this.call({ url: "/wishlist/get" })];
                    case 1:
                        response = _a.sent();
                        return [2, response.data.data];
                    case 2:
                        e_1 = _a.sent();
                        errors = get_1.default(e_1, "response.data.errors");
                        console.error("CustomerApi::getWishlist", e_1, errors ? errors : "");
                        throw new Error("" + (errors ? errors.join("\n") : ""));
                    case 3: return [2];
                }
            });
        });
    };
    CustomerApi.prototype.getCart = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2, this.ajaxApi.get("/cart.js")];
            });
        });
    };
    CustomerApi.prototype.fillCartWithItems = function (items) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2, new Promise(function (resolve) {
                        _this.ajaxApi.post("/cart/clear").then(function () {
                            var cartChangeUrl = "/cart/update?" +
                                items
                                    .map(function (i) { return "updates[" + i.id + "]=" + parseInt(i.quantity); })
                                    .join("&");
                            console.log("fillCartWithItems::", cartChangeUrl);
                            _this.ajaxApi.post(cartChangeUrl).then(resolve);
                        });
                    })];
            });
        });
    };
    CustomerApi.prototype.emptyCart = function () {
        return __awaiter(this, void 0, void 0, function () {
            var url;
            return __generator(this, function (_a) {
                url = "/cart/clear";
                return [2, axios_1.default.post(url)];
            });
        });
    };
    return CustomerApi;
}());
exports.default = CustomerApi;
